import ajax from '../../common/services/httpService'

const BASE_URL = 'change-history'

/**
 * @param {{
 *  page?: number,
 *  limit?: number,
 *  search?: string,
 *  searchBy?: string,
 *  changeSource?: string,
 *  entityType?: string,
 *  from?: string,
 *  to?: string,
 *  siteId?: number,
 *  companyId?: number,
 * }} [query]
 */
async function getHistory(query = {}) {
	return ajax.get(BASE_URL, null, query)
}

export default {
	getHistory,
}
